import axios  from "axios";

const API_URL = process.env.REACT_APP_API_URL + "sales-return";

class SalesReturn {
  create = async (val: any) => {
    const res = await axios.post<any>(API_URL, val)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data;
  };

  edit = async (val: any, code: any) => {
    await axios.put<any>(`${API_URL}/${code}`, val)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.salesReturn;
  };

  getAll = async () => {
    const response = await axios.get<any>(API_URL)
      .catch((e) => {
        throw e.message;
      });
    return response.data.salesReturn;
  };

  reversal = async (code: any) => {
    const response = await axios.put<any>(`${API_URL}-reversal`, code)
      .catch((e) => {
        throw e.message;
      });
    return response.data;
  };
}

export default new SalesReturn();
